import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { categories } from "@/mocks/comics";

export default function Navbar() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-background-50/95 backdrop-blur-md border-b border-background-200/70" role="navigation" aria-label="主导航">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="韩漫画网首页">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-book-open-line text-2xl text-primary-500"></i>
            </div>
            <span className="text-lg font-semibold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>韩漫画网</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${isActive("/") ? "text-primary-500" : "text-foreground-700 hover:text-primary-500"}`}
            >
              首页
            </Link>
            <div className="relative group">
              <button className="flex items-center gap-1 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                分类浏览
                <i className="ri-arrow-down-s-line text-sm"></i>
              </button>
              <div className="absolute top-full left-1/2 -translate-x-1/2 pt-4 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <div className="bg-background-50 border border-background-200/70 rounded-lg p-2 shadow-sm min-w-[200px]">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-3 px-4 py-2.5 rounded-md text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 transition-colors duration-150 whitespace-nowrap cursor-pointer"
                    >
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className={`${cat.icon} text-base`}></i>
                      </div>
                      <span>{cat.name}</span>
                      <span className="ml-auto text-xs text-foreground-600">{cat.count}</span>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${isActive("/about") ? "text-primary-500" : "text-foreground-700 hover:text-primary-500"}`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            {searchOpen ? (
              <div className="flex items-center gap-2 bg-background-100 rounded-full px-4 py-2 border border-background-200/70">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-search-line text-sm text-foreground-600"></i>
                </div>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="搜索漫画..."
                  className="bg-transparent text-sm text-foreground-950 placeholder-foreground-600 outline-none w-40"
                  autoFocus
                  onBlur={() => { if (!searchQuery) setSearchOpen(false); }}
                />
                <button onClick={() => { setSearchOpen(false); setSearchQuery(""); }} className="cursor-pointer">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-close-line text-sm text-foreground-600"></i>
                  </div>
                </button>
              </div>
            ) : (
              <button
                onClick={() => setSearchOpen(true)}
                className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-100 transition-colors duration-200 cursor-pointer"
                aria-label="搜索"
              >
                <i className="ri-search-line text-lg text-foreground-700"></i>
              </button>
            )}
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors duration-200 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl text-foreground-700 ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4">
          <div className="flex flex-col gap-2">
            <Link to="/" onClick={() => setMobileOpen(false)} className={`px-3 py-2.5 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isActive("/") ? "bg-primary-100 text-primary-500" : "text-foreground-700 hover:bg-background-100"}`}>
              首页
            </Link>
            <div className="px-3 py-2 text-xs font-semibold text-foreground-600 uppercase tracking-wide">分类浏览</div>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                onClick={() => setMobileOpen(false)}
                className="flex items-center gap-3 px-3 py-2.5 rounded-md text-sm text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${cat.icon} text-base`}></i>
                </div>
                {cat.name}
              </Link>
            ))}
            <Link to="/about" onClick={() => setMobileOpen(false)} className={`px-3 py-2.5 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isActive("/about") ? "bg-primary-100 text-primary-500" : "text-foreground-700 hover:bg-background-100"}`}>
              关于我们
            </Link>
            <div className="mt-2 px-3">
              <div className="flex items-center gap-2 bg-background-100 rounded-full px-4 py-2.5 border border-background-200/70">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-search-line text-sm text-foreground-600"></i>
                </div>
                <input
                  type="text"
                  placeholder="搜索漫画..."
                  className="bg-transparent text-sm text-foreground-950 placeholder-foreground-600 outline-none flex-1"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}